import { createAction } from '@reduxjs/toolkit';

import type { Project, PublicVideo, VideoStatus, VideoVisibility, Workspace } from 'js/src/client';
import type { PublicVideoRenderEstimate } from 'js/src/data/share-video/share-video-types';
import { SHARE_VIDEO_ACTIONS } from 'js/src/data/share-video/share-video-types';

export const storeVideo = createAction<PublicVideo>(SHARE_VIDEO_ACTIONS.STORE_VIDEO);

export const storeProject = createAction<Project>(SHARE_VIDEO_ACTIONS.STORE_PROJECT);

export const storeVideoMembers = createAction<{
    workspaces: Workspace[];
    project: Project;
}>(SHARE_VIDEO_ACTIONS.STORE_VIDEO_MEMBERS);

export const storeRenderEstimate = createAction<PublicVideoRenderEstimate>(
    SHARE_VIDEO_ACTIONS.STORE_RENDER_ESTIMATE,
);

export const setLoadingFinished = createAction(SHARE_VIDEO_ACTIONS.SET_LOADING_FINISHED);

export const setVideoVisibility = createAction<VideoVisibility>(
    SHARE_VIDEO_ACTIONS.SET_VIDEO_VISIBILITY,
);

export const setVideoStatus = createAction<VideoStatus>(SHARE_VIDEO_ACTIONS.SET_VIDEO_STATUS);

export const setVideoName = createAction<string>(SHARE_VIDEO_ACTIONS.SET_VIDEO_NAME);

export const startAutoDownload = createAction(SHARE_VIDEO_ACTIONS.START_AUTO_DOWNLOAD);

/**
 * Records a non-mp4 download the user queued from the Creator (currently only carousel images).
 * Read from the URL once on mount, because the share page strips the param immediately and the
 * render poll that arms the mp4 download resolves long after that.
 */
export const setQueuedArtifactDownload = createAction<string | null>(
    SHARE_VIDEO_ACTIONS.SET_QUEUED_ARTIFACT_DOWNLOAD,
);
